<template>
  <v-app>

    <component :is="layout">
      <router-view/>
    </component>

    <v-snackbar v-model="snackWithButtons" :timeout="timeout" bottom left class="snack">
      {{ snackWithBtnText }}
      <v-spacer />
      <v-btn dark text color="teal" @click.native="refreshApp">{{ snackBtnText }}</v-btn>
      <v-btn icon @click="snackWithButtons = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
export default {
  name: 'App',

  computed: {
    layout () {
      return (this.$route.meta.layout || 'app') + '-layout'
    }
  },
  data: () => ({

    refreshing: false,
    registration: null,
    snackBtnText: '',
    snackWithBtnText: '',
    snackWithButtons: false,
    timeout: 0

  }),
  created () {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
  },
  methods: {

    showRefreshUI (e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail
      this.snackBtnText = 'Perbarui'
      this.snackWithBtnText = 'Pembaruan tersedia!'
      this.snackWithButtons = true
    },
    refreshApp () {
      window.location.reload()
    }

  }

}
</script>
<style scoped>
/* Provide better right-edge spacing when using an icon button there. */
.snack >>> .v-snack__content {
  padding-right: 16px;
}
</style>
